const productPaths = {
  products: '/product',
  bundles: '/product/bundles',
  editBundle: (id = ':id') => `/product/bundles/${id}/edit`,
  bundleComponents: (id = ':id') => `/product/bundles/${id}/components`,
  editProduct: (id = ':id') => `/product/${id}/edit`,
  variants: (id = ':id') => `/product/${id}/variants`,
  productSettings: '/product/settings',
};

export default productPaths;
